import { STUDY_SUBJECTS, studySubjects } from '../../dailyStudySubjects';
export const SUBJECTS = STUDY_SUBJECTS.map(([key, label]) => [key, ({ fen_bilimleri: 'Fen', sosyal_bilgiler: 'Sosyal', din_kulturu: 'Din' })[key] || label]);
export const WEEKDAYS = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];

export function todayInIstanbul() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}
export function shiftDay(day, offset) {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + offset);
  return date.toISOString().slice(0, 10);
}
export function monday(day) {
  return shiftDay(day, -((new Date(`${day}T12:00:00Z`).getUTCDay() + 6) % 7));
}
export function formatDay(day, withYear = true) {
  return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', ...(withYear ? { year: 'numeric' } : {}), timeZone: 'UTC' }).format(new Date(`${day}T12:00:00Z`));
}
export function fullName(student) { return `${student.name || ''} ${student.surname || ''}`.trim(); }
export function isStudyClass(item) {
  const grade = Number(item.grade_level ?? item.grade ?? String(item.name || item.code || '').match(/^\d+/)?.[0]);
  return grade >= 4 && grade <= 12;
}
export function subjectTotal(records, key) {
  return records.reduce((sum, record) => sum + Number(record.subjects?.[key] || 0), 0);
}
export function questionCell(student, date, subject = 'all') {
  const record = student.records.find((item) => item.date === date);
  return record ? (subject === 'all' ? record.questions : Number(record.subjects?.[subject] || 0)) : null;
}

export function buildDashboard(data, start, end, today, weekly = true) {
  const dates = Array.from({ length: Math.round((new Date(`${end}T12:00:00Z`) - new Date(`${start}T12:00:00Z`)) / 86400000) + 1 }, (_, i) => shiftDay(start, i));
  const elapsed = dates.filter((day) => day <= today).length;
  const students = (data?.items || []).map((student) => {
    const records = (student.records || []).filter((r) => r.date >= start && r.date <= end && r.date <= today);
    return { ...student, records, days: records.length, questions: records.reduce((sum, r) => sum + r.questions, 0), pages: records.reduce((sum, r) => sum + r.pages, 0) };
  }).sort((a, b) => fullName(a).localeCompare(fullName(b), 'tr-TR') || String(a.id).localeCompare(String(b.id)));
  const participants = students.filter((s) => s.days > 0).length;
  const questions = students.reduce((sum, s) => sum + s.questions, 0);
  const pages = students.reduce((sum, s) => sum + s.pages, 0);
  const recentDates = data?.recent_completed_dates || [];
  const attention = students.map((student) => {
    let reason = null;
    let priority = 0;
    if (!student.days) { reason = weekly ? 'Bu hafta hiç kayıt yok' : 'Bu gün kayıt yok'; priority = 1; }
    else if (weekly && recentDates.length === 3 && !(student.recent_record_dates || []).some((date) => recentDates.includes(date))) { reason = 'Son 3 tamamlanmış gündür kayıt yok'; priority = 2; }
    else if (weekly && student.days === 1) { reason = 'Bu hafta yalnızca 1 gün kayıt var'; priority = 3; }
    return { ...student, reason, priority };
  }).filter((s) => s.reason).sort((a, b) => a.priority - b.priority || fullName(a).localeCompare(fullName(b), 'tr-TR'));
  const allRecords = students.flatMap((s) => s.records);
  const distribution = studySubjects(data?.subject_options, SUBJECTS).map(([key, label]) => ({ key, label, value: subjectTotal(allRecords, key) })).sort((a, b) => b.value - a.value);
  return {
    dates, elapsed, students, participants, attention, distribution,
    averageDays: students.length ? students.reduce((sum, s) => sum + s.days, 0) / students.length : null,
    averageQuestions: participants ? questions / participants : null,
    averagePages: participants ? pages / participants : null,
    regularCount: students.filter((s) => s.days >= 4).length,
    daily: dates.map((date, i) => {
      const records = allRecords.filter((r) => r.date === date);
      return { date, label: weekly ? WEEKDAYS[i] : formatDay(date, false), future: date > today, count: records.length, value: records.length ? records.reduce((sum, r) => sum + r.questions, 0) / records.length : null };
    }),
  };
}
